import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { useResponsive } from '@/hooks/common/useResponsive';
import { DesktopTabsHeader, TabItem } from '@/components/common/residents/desktop/DesktopTabsHeader';

interface MaintenanceNavigationProps {
  activeTab: 'open' | 'closed';
  onTabChange: (tab: 'open' | 'closed') => void;
}

export const MaintenanceNavigation: React.FC<MaintenanceNavigationProps> = ({
  activeTab,
  onTabChange,
}) => {
  const { layoutMode } = useResponsive();
  const isDesktop = layoutMode === 'desktop';

  const tabItems: TabItem[] = [
    {
      key: 'open',
      title: 'Open',
      subtitle: 'View all of the requests in progress',
      borderColor: '#3B82F6', // blue-500
    },
    {
      key: 'closed',
      title: 'Closed',
      subtitle: 'History of completed requests',
      borderColor: '#F55560', // red (matching how it works tab)
    },
  ];

  if (!isDesktop) {
    // Mobile navigation - simple tab bar
    return (
      <View style={styles.mobileNavContainer}>
        {tabItems.map((item) => (
          <TouchableOpacity
            key={item.key}
            style={[
              styles.mobileNavItem,
              activeTab === item.key && {
                borderBottomColor: item.borderColor,
                borderBottomWidth: 3,
              },
            ]}
            onPress={() => onTabChange(item.key as 'open' | 'closed')}
          >
            <Text
              style={[
                styles.mobileNavTitle,
                activeTab === item.key && { color: item.borderColor },
              ]}
            >
              {item.title}
            </Text>
          </TouchableOpacity>
        ))}
      </View>
    );
  }

  // Desktop navigation - use reusable DesktopTabsHeader
  return (
    <DesktopTabsHeader
      tabs={tabItems}
      activeTab={activeTab}
      onTabChange={(tabKey) => onTabChange(tabKey as 'open' | 'closed')}
    />
  );
};

const styles = StyleSheet.create({
  // Mobile styles
  mobileNavContainer: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  mobileNavItem: {
    flex: 1,
    paddingVertical: 16,
    alignItems: 'center',
    justifyContent: 'center',
    borderBottomWidth: 3,
    borderBottomColor: 'transparent',
  },
  mobileNavTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#6B7280',
  },
});
